const IconsReverse = new Set<Icon>([
  'avatarnext',
  'avatarprevious',
  'arrow_next',
  'channel',
  'chatspinned',
  'fast_forward_filled',
  'fast_rewind_filled',
  'forward',
  'forward_filled',
  'group',
  'group_filled',
  'left',
  'listscreenshare_filled',
  'logout',
  'muted',
  'newchannel_filled',
  'newchannel',
  'newgroup',
  'newgroup_filled',
  'next',
  'nosound_filled',
  'previous',
  'send_filled',
  'send2',
  'reply',
  'reply_filled',
  'sharescreen_filled',
  'transcribe',
  'storyreply',
  'premium_noads_filled',
  'topics',
  'pinlist',
  'deleteleft'
]);

export default IconsReverse;
